import type { PrintLocation } from '../types/pricing';
import { MAX_DIMENSIONS } from '../config/constants';

export function validateUsername(username: string): boolean {
  return /^[a-zA-Z0-9-]+$/.test(username);
}

export function validateDimensions(location: PrintLocation, dimensions: string): boolean {
  const [width = 0, height = 0] = dimensions.split('x').map(Number);
  const maxDim = MAX_DIMENSIONS[location];
  
  return width > 0 && 
         height > 0 && 
         width <= maxDim.width && 
         height <= maxDim.height;
}

export function validateQuantity(quantity: number, minQuantity: number): number {
  return Math.max(minQuantity, Math.floor(quantity) || minQuantity);
}